'use client'

import * as React from "react";
import { DayPicker } from "react-day-picker";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps)
{
 


  React.useEffect(() => {

  }, []);
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      disabled={(date) => date <= new Date()}
      className={cn("p-3 max-w-[22rem] sm:max-w-none w-full", className)}
      classNames={{
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0 sm:w-full",
        month: "space-y-4 sm:w-full ",
        caption: "flex justify-center pt-1 relative items-center sm:w-full",
        caption_label: "text-[0.7rem] font-bold text-white",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent border-white/20 text-white p-0 hover:bg-white/10 hover:text-white"
        ),
        nav_button_previous: "absolute left-16",
        nav_button_next: "absolute right-16",
        table: "w-full border-collapse space-y-1",
        head_row: "flex w-full sm:px-[0.2rem] justify-between border-b pb-2",
        head_cell:
          "text-white font-bold text-[0.9rem] sm:w-10 text-center px-[0.9rem] sm:px-0",
        row: "flex sm:w-full",
        cell: cn(
          "relative p-1 sm:px-[0.5rem] text-center text-sm rounded-full hover:bg-white/10 hover:text-white w-full",
          "[&:has([aria-selected])]:rounded-full text-white"
        ),
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-10 w-10 p-0 text-white rounded-full"
        ),
        day_selected:
        "bg-purple2 text-white rounded-full",
        day_today: "bg-blue2 text-white font-bold rounded-full",
        day_outside:
          "text-gray-400 opacity-50",
        day_disabled: "text-gray-500 opacity-50 cursor-not-allowed",
        day_hidden: "invisible",
        ...classNames,
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };